import styled from 'styled-components';
export const Container = styled.div`
  position: fixed;
  display: ${({isOpen}) => isOpen ?'flex':'none'};
  top:0px;
  left: 0px;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  cursor: default;
  background-color: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(5px); 
  animation: ModalShow .1s ease-out;
  user-select: none;
  @keyframes ModalShow{
    0% {
      opacity: 0;
      transform: scale(1.2);
    }
    100% {
      opacity: 0;
      transform: scale(1);
    }
  }
`;
export const Content = styled.div`
  display: flex;
  min-width:300px;
  border-radius: 6px;
  flex-direction: column;
  background-color: #f6f6f6;
  p{
    margin: 0px;
  }
`;
export const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 80px;
  padding: 10px;
  justify-content: center;
`;
export const Title = styled.p`
  display: flex;
  width: 100%;
  text-align: center;
  justify-content: center;
  font-size:1.2rem;
  font-weight: 500;
  color: #000000;
`;
export const Children = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Actions = styled.div`
  display: flex;
  width: 100%;
  color: #000000;
  border-top: 1px solid #82878b33;
  div{
    display: flex;
    width:50%;
    height: 35px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size:1.2rem;
    font-weight: 500;
    &:hover{
      background-color: #716d6917;
    }
  }
  div:nth-child(1){
    border-right: 1px solid #82878b33;
    border-radius: 0 0 0 6px;
    &:hover{
      color:#1D86FF;
    }
  }
  div:nth-child(2){
    border-radius: 0 0 6px 0;
    &:hover{
      color: #ce3747;
    }
  }
`;